import { useMutation } from "@tanstack/react-query";
import type { SellarImportDocumentDownloadResponseType } from "@sellar-io/api-v2/types";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../../../hooks/useFirebaseUser.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
} from "../../../../../hooks/api/v2/apiV2Request";

export const useSellarImportRevenueInvoiceDownload = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: ({ sellarImportPayoutId }: { sellarImportPayoutId: number }) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `sellar-imports/finance/payouts/${sellarImportPayoutId}/revenue-invoice/download`,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as SellarImportDocumentDownloadResponseType,
      ),
  });
};
